// Recovered compiled webpack factory 90535. Edit this function expression; run npm run build.
() => {
  ("trimStart" in String.prototype || (String.prototype.trimStart = String.prototype.trimLeft),
    "trimEnd" in String.prototype || (String.prototype.trimEnd = String.prototype.trimRight),
    "description" in Symbol.prototype ||
      Object.defineProperty(Symbol.prototype, "description", {
        configurable: !0,
        get: function () {
          var e = /\((.*)\)/.exec(this.toString());
          return e ? e[1] : void 0;
        },
      }),
    Array.prototype.flat ||
      ((Array.prototype.flat = function (e, t) {
        return (
          (t = this.concat.apply([], this)),
          e > 1 && t.some(Array.isArray) ? t.flat(e - 1) : t
        );
      }),
      (Array.prototype.flatMap = function (e, t) {
        return this.map(e, t).flat();
      })),
    Promise.prototype.finally ||
      (Promise.prototype.finally = function (e) {
        if ("function" != typeof e) return this.then(e, e);
        var t = this.constructor || Promise;
        return this.then(
          function (r) {
            return t.resolve(e()).then(function () {
              return r;
            });
          },
          function (r) {
            return t.resolve(e()).then(function () {
              throw r;
            });
          },
        );
      }),
    Object.fromEntries ||
      (Object.fromEntries = function (e) {
        return Array.from(e).reduce(function (e, t) {
          return ((e[t[0]] = t[1]), e);
        }, {});
      }),
    Array.prototype.at ||
      (Array.prototype.at = function (e) {
        var t = Math.trunc(e) || 0;
        if ((t < 0 && (t += this.length), !(t < 0 || t >= this.length))) return this[t];
      }),
    Object.hasOwn ||
      (Object.hasOwn = function (e, t) {
        if (null == e) throw TypeError("Cannot convert undefined or null to object");
        return Object.prototype.hasOwnProperty.call(Object(e), t);
      }),
    "canParse" in URL ||
      (URL.canParse = function (e, t) {
        try {
          return (new URL(e, t), !0);
        } catch (e) {
          return !1;
        }
      }));
}
